var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import { FixedPositionType } from '../../element-setting/shared/display/fixed-position-type';
/**
 * @ignore
 * Internal class that remembers a Part's offset & angle.
 */
var PartInfo = /** @class */ (function () {
    function PartInfo(placementAngle, distance, rotationAngle) {
        this.placementAngle = placementAngle * (Math.PI / 180); // in radians
        this.distance = distance;
        this.rotationAngle = rotationAngle; // in degrees
    }
    return PartInfo;
}());
export { PartInfo };
var RotateMultipleTool = /** @class */ (function (_super) {
    __extends(RotateMultipleTool, _super);
    /**
     * @constructor
     * @extends RotatingTool
     * @class
     * A custom tool for rotating multiple objects at a time. When more than one
     * part is selected, rotates all parts, revolving them about their collective center.
     * If the control key is held down during rotation, rotates all parts individually.
     */
    function RotateMultipleTool() {
        var _this = _super.call(this) || this;
        _this._handle = null;
        _this.name = 'RotateMultiple';
        // holds references to all selected non-Link Parts and their offset & angles
        _this.initialInfo = null;
        // initial angle when rotating as a whole
        _this.initialAngle = 0;
        // rotation point of selection
        _this.centerPoint = null;
        return _this;
    }
    Object.defineProperty(RotateMultipleTool.prototype, "handle", {
        get: function () { return this._handle; },
        enumerable: true,
        configurable: true
    });
    /**
     * Calls RotatingTool.doActivate, and then remembers the center point of the collection,
     * and the initial distances and angles of selected parts to the center.
     * @this {RotateMultipleTool}
     */
    RotateMultipleTool.prototype.doActivate = function () {
        go.RotatingTool.prototype.doActivate.call(this);
        var diagram = this.diagram;
        if (diagram === null) {
            return;
        }
        this._handle = this.findToolHandleAt(diagram.firstInput.documentPoint, this.name);
        if (this._handle === null) {
            return;
        }
        var shape = this.handle.part.adornedObject;
        // center point of the collection
        var fixedPositionType;
        if (shape.part.findObject('SHAPE')) {
            fixedPositionType = shape.part.findObject('SHAPE').panel.data.fixedPositionType !== undefined ? shape.part.findObject('SHAPE').panel.data.fixedPositionType : 0;
        }
        else {
            fixedPositionType = shape.part.data.fixedPositionType !== undefined ? shape.part.data.fixedPositionType : 0;
        }
        var strokeWidth = shape.part.data.strokeWidth ? shape.part.data.strokeWidth : 0;
        var width = shape.naturalBounds.width - strokeWidth;
        var height = shape.naturalBounds.height - strokeWidth;
        var centerX = diagram.computePartsBounds(diagram.selection).center.x;
        var centerY = diagram.computePartsBounds(diagram.selection).center.y;
        var halfOfHypotenuse = Math.sqrt(width * width + height * height) / 2;
        var widthAndHeightTangentAngle = Math.atan(width / height);
        var rotateAngle = this.adornedObject.part.rotateObject.angle * (Math.PI / 180);
        switch (fixedPositionType) {
            case FixedPositionType.TopLeft:
                this.centerPoint =
                    new go.Point(centerX - Math.sin(widthAndHeightTangentAngle - rotateAngle) * halfOfHypotenuse, centerY - Math.cos(widthAndHeightTangentAngle - rotateAngle) * halfOfHypotenuse);
                break;
            case FixedPositionType.TopCenter:
                this.centerPoint = new go.Point(centerX + Math.sin(rotateAngle) * height / 2, centerY - Math.cos(rotateAngle) * height / 2);
                break;
            case FixedPositionType.TopRight:
                this.centerPoint = new go.Point(centerX + Math.sin(widthAndHeightTangentAngle + rotateAngle) * halfOfHypotenuse, centerY - Math.cos(widthAndHeightTangentAngle + rotateAngle) * halfOfHypotenuse);
                break;
            case FixedPositionType.CenterLeft:
                this.centerPoint = new go.Point(centerX - Math.cos(rotateAngle) * width / 2, centerY - Math.sin(rotateAngle) * width / 2);
                break;
            case FixedPositionType.CenterCenter:
                this.centerPoint = diagram.computePartsBounds(diagram.selection).center;
                break;
            case FixedPositionType.CenterRight:
                this.centerPoint = new go.Point(centerX + Math.cos(rotateAngle) * width / 2, centerY + Math.sin(rotateAngle) * width / 2);
                break;
            case FixedPositionType.BottomLeft:
                this.centerPoint = new go.Point(centerX - Math.sin(widthAndHeightTangentAngle + rotateAngle) * halfOfHypotenuse, centerY + Math.cos(widthAndHeightTangentAngle + rotateAngle) * halfOfHypotenuse);
                break;
            case FixedPositionType.BottomCenter:
                this.centerPoint = new go.Point(centerX - Math.sin(rotateAngle) * height / 2, centerY + Math.cos(rotateAngle) * height / 2);
                break;
            case FixedPositionType.BottomRight:
                this.centerPoint = new go.Point(centerX + Math.sin(widthAndHeightTangentAngle - rotateAngle) * halfOfHypotenuse, centerY + Math.cos(widthAndHeightTangentAngle - rotateAngle) * halfOfHypotenuse);
                break;
            default:
                this.centerPoint = diagram.computePartsBounds(diagram.selection).center;
                break;
        }
        // remember the angle relative to the center point when rotating the whole collection
        this.initialAngle = this.centerPoint.directionPoint(diagram.lastInput.documentPoint);
        // remember initial angle and distance for each Part
        var infos = new go.Map(go.Part, PartInfo);
        var tool = this;
        diagram.selection.each(function (part) {
            tool.walkTree(part, infos);
        });
        this.initialInfo = infos;
    };
    /**
    * @ignore
    * @param {Part} part
    * @param {Map} infos
    */
    RotateMultipleTool.prototype.walkTree = function (part, infos) {
        if (part === null || part instanceof go.Link) {
            return;
        }
        // distance from centerPoint to locationSpot of part
        var dist = Math.sqrt(this.centerPoint.distanceSquaredPoint(part.location));
        // calculate initial relative angle
        var dir = this.centerPoint.directionPoint(part.location);
        // saves part-angle combination in array
        infos.add(part, new PartInfo(dir, dist, part.rotateObject.angle));
        // recurse into Groups
        if (part instanceof go.Group) {
            var it = part.memberParts.iterator;
            while (it.next()) {
                this.walkTree(it.value, infos);
            }
        }
    };
    /**
     * Clean up any references to Parts.
     * @this {RotateMultipleTool}
     */
    RotateMultipleTool.prototype.doDeactivate = function () {
        this.initialInfo = null;
        go.RotatingTool.prototype.doDeactivate.call(this);
    };
    /**
     * Overrides rotatingTool.rotate to rotate all selected objects about their collective center.
     * When the control key is held down while rotating, all selected objects are rotated individually.
     * @this {RotateMultipleTool}
     * @param {number} newangle
     */
    RotateMultipleTool.prototype.rotate = function (newangle) {
        var diagram = this.diagram;
        if (diagram.selection.count > 1) {
            return;
        }
        var e = diagram.lastInput;
        // when rotating individual parts, remember the original angle difference
        var angleDiff = newangle - this.adornedObject.part.rotateObject.angle;
        var tool = this;
        this.initialInfo.each(function (kvp) {
            var part = kvp.key;
            if (part instanceof go.Link) {
                return;
            } // only Nodes and simple Parts
            var partInfo = kvp.value;
            // rotate every selected non-Link Part
            // find information about the part set in RotateMultipleTool.initialInformation
            if (e.control || e.meta) {
                if (tool.adornedObject.part === part) {
                    part.rotateObject.angle = newangle;
                }
                else {
                    part.rotateObject.angle += angleDiff;
                }
            }
            else {
                var radAngle = newangle * (Math.PI / 180); // converts the angle traveled from degrees to radians
                // calculate the part's x-y location relative to the central rotation point
                var offsetX = partInfo.distance * Math.cos(radAngle + partInfo.placementAngle);
                var offsetY = partInfo.distance * Math.sin(radAngle + partInfo.placementAngle);
                // move part
                part.location = new go.Point(tool.centerPoint.x + offsetX, tool.centerPoint.y + offsetY);
                // rotate part
                part.rotateObject.angle = partInfo.rotationAngle + newangle;
            }
        });
    };
    /**
     * This override needs to calculate the desired angle with different rotation points,
     * depending on whether we are rotating the whole selection as one, or Parts individually.
     * @this {RotateMultipleTool}
     * @param {Point} newPoint in document coordinates
     */
    RotateMultipleTool.prototype.computeRotate = function (newPoint) {
        var diagram = this.diagram;
        var angle;
        var e = diagram.lastInput;
        if (e.control || e.meta) { // relative to the center of the Node whose handle we are rotating
            var part = this.adornedObject.part;
            var rotationPoint = part.getDocumentPoint(part.locationSpot);
            angle = rotationPoint.directionPoint(newPoint);
        }
        else { // relative to the center of the whole selection
            angle = this.centerPoint.directionPoint(newPoint) - this.initialAngle;
        }
        if (angle >= 360) {
            angle -= 360;
        }
        else if (angle < 0) {
            angle += 360;
        }
        var interval = Math.min(Math.abs(this.snapAngleMultiple), 180);
        var epsilon = Math.min(Math.abs(this.snapAngleEpsilon), interval / 2);
        // if it's close to a multiple of INTERVAL degrees, make it exactly so
        if (!diagram.lastInput.shift && interval > 0 && epsilon > 0) {
            if (angle % interval < epsilon) {
                angle = Math.floor(angle / interval) * interval;
            }
            else if (angle % interval > interval - epsilon) {
                angle = (Math.floor(angle / interval) + 1) * interval;
            }
            if (angle >= 360) {
                angle -= 360;
            }
            else if (angle < 0) {
                angle += 360;
            }
        }
        return angle;
    };
    return RotateMultipleTool;
}(go.RotatingTool));
export { RotateMultipleTool };
